import { createRouter } from '@tanstack/react-router'
import type { Container } from '@thom/folio-ui/app/container'
import { isRememberedList, rememberFilters } from '@thom/folio-ui/routing/list-filters'
import { stringifySearch } from '@thom/folio-ui/routing/stringify-search'
import { routeTree } from '@thom/folio-ui/routeTree.gen'

const createFolioRouter = (container: Container) => {
	const router = createRouter({ routeTree, context: { container }, stringifySearch })

	router.subscribe('onResolved', () => {
		const leaf = router.state.matches.at(-1)
		if (leaf && isRememberedList(leaf.routeId))
			rememberFilters(container.listMemory, leaf.routeId, leaf.search as Record<string, unknown>)
	})

	return router
}

declare module '@tanstack/react-router' {
	interface Register {
		router: ReturnType<typeof createFolioRouter>
	}
}

export { createFolioRouter }
